import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BulletsIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_4_13)">
        <path
          d="M14.8737 27.0001V12C14.8737 11.7235 14.6353 11.5 14.3404 11.5H4.74034C4.44538 11.5 4.20703 11.7235 4.20703 12V27.0001C4.20703 27.2766 4.44544 27.5001 4.74034 27.5001V28C4.44538 28 4.20703 28.2235 4.20703 28.5001V30.4999C4.20703 30.7765 4.44544 31 4.74034 31H14.3404C14.6354 31 14.8737 30.7765 14.8737 30.4999V28.5001C14.8737 28.2235 14.6353 28.0002 14.3404 28.0002V27.5001C14.6353 27.5001 14.8737 27.2766 14.8737 27.0001Z"
          fill="currentColor"
        />
        <path
          d="M5.27365 10.5001H13.807C14.102 10.5001 14.3403 10.2766 14.3403 10.0001V9.50018C14.3403 6.21319 12.6651 3.07317 9.8603 1.10012C9.67044 0.966626 9.41018 0.966626 9.2203 1.10012C6.4155 3.07317 4.74028 6.21314 4.74028 9.50018V10.0001C4.74034 10.2766 4.97869 10.5001 5.27365 10.5001Z"
          fill="currentColor"
        />
        <path
          d="M27.5404 27.5001V14.375C27.5404 14.133 27.3318 13.9375 27.0738 13.9375H18.6737C18.4156 13.9375 18.207 14.1331 18.207 14.375V27.5001C18.207 27.742 18.4156 27.9376 18.6737 27.9376V28.375C18.4156 28.375 18.207 28.5706 18.207 28.8124V30.5626C18.207 30.8044 18.4156 31 18.6737 31H27.0738C27.3318 31 27.5404 30.8044 27.5404 30.5626V28.8126C27.5404 28.5706 27.3318 28.3752 27.0738 28.3752V27.9376C27.3318 27.9376 27.5404 27.742 27.5404 27.5001Z"
          fill="currentColor"
        />
        <path
          d="M19.1403 13.0626H26.607C26.8652 13.0626 27.0736 12.867 27.0736 12.6251V12.1877C27.0736 9.31154 25.6078 6.56403 23.1536 4.8376C22.9875 4.72081 22.7598 4.72081 22.5936 4.8376C20.1394 6.56403 18.6736 9.31148 18.6736 12.1877V12.6251C18.6737 12.867 18.8822 13.0626 19.1403 13.0626Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_13">
          <rect width="24" height="30" fill="currentColor" transform="translate(4 1)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
